// frontend\src\hooks\useFileExport.js
import { useState } from 'react';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

export const useFileExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);

  const exportFile = async (apiCall, fileName, successMessage = 'Файл успешно экспортирован!') => {
    setIsExporting(true);
    setExportProgress(0);

    try {
      const response = await apiCall({
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 100)
          );
          setExportProgress(Math.max(95, percent));
        },
      });

      setExportProgress(100);
      saveAs(new Blob([response.data]), fileName);
      toast.success(successMessage);
    } catch (error) {
      console.error("Ошибка экспорта:", error);
      toast.error("Ошибка при экспорте файла!");
    } finally {
      setIsExporting(false);
      setTimeout(() => setExportProgress(0), 1000);
    }
  };

  return { isExporting, exportProgress, exportFile };
};